import { authRoles } from 'app/auth';
import { lazy } from 'react';


const ReviewOrderPage = lazy(() => import('./ReviewOrderPage'));
const ReviewOrderActionPage = lazy(()=>import('./ReviewOrderAction'))
const ReviewShipmentPage = lazy(()=>import('./ReviewShipmentPage'))

const ReviewOrderPageConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  // Removed authRoles.onlyGuest so that both logged-in and not logged-in users can access this page
  auth: null,
  routes: [
    {
      path: 'process/:token',
      element: <ReviewOrderPage/>,
    },
    {
      path: 'processShipment/:token',
      element: <ReviewShipmentPage/>,
    },
    {
        path:'process-response/:Id',
        element:<ReviewOrderActionPage/>
    }
  ],
};

export default ReviewOrderPageConfig;
